// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import DECLINE from "../../assets/Declined.png";

class DocAcceptanceRejectedStatusUpdate extends Component {
  _onClose = () => {
    this.props.toggleModalPopUp("docRejecteConfirmationPopup", false);
  };

  render() {
    return (
      <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="docstatus-accptancereject-image">
            <div className="docstatus-confirm-text">
              <div className="doc-confirm-seal">
                <img
                  src={DECLINE}
                  alt="Decline badge"
                  className="document-sent-confirmation-image"
                />
              </div>
              <div className="docstatus-confirm-title">
                You have rejected this document.
              </div>
              <div className="docstatus-confirm-subtitle">
                You can add comments to support your action under Notes.
              </div>
              <div className="acceptance-docstatus-confirm-footer">
                You can access this document any time using the link in the
                email.
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DocAcceptanceRejectedStatusUpdate;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocAcceptanceRejectedStatusUpdate.js